import map from "lodash/map"


export class GetFlatResponse {
    constructor(responseJSON) {
        this.responseJSON = responseJSON;
    }

    getHousingName() {
        return this.responseJSON["housingName"];
    }

    getSectionName() {
        return this.responseJSON["sectionNumber"];
    }

    getSectionImage() {
        return this.responseJSON["housingImage"];
    }

    getThousands(num) {
        if (num) {
            return num.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
        }
    }

    getFlatNumber() {
        return this.responseJSON['number'];
    }

    getFloorNumber() {
        return this.responseJSON['floorNumber'];
    }

    getFlatRooms() {
        return this.responseJSON['rooms'];
    }

    getFlatSpace() {
        return this.responseJSON['space'];
    }

    getFlatPrice() {
        return this.getThousands(this.responseJSON['fullPrice']);
    }

  getFloorNumber() {
    return this.getThousands(this.responseJSON['floorNumber']);
  }

    getFlatPricePMeter() {
        return this.getThousands(this.responseJSON['price']);
    }

    getPlan() {
        return this.responseJSON['imagePlanApartmentUrl']
    }


    getFinishedStatus() {
        let finishedStatus = this.responseJSON["sectionFinished"];
        if (!finishedStatus) {
            return '';
        } else {
            return finishedStatus;
        }
    }

    getPdf() {
        return this.responseJSON['pdfUrl'];
    }

    isFavorite() {
        return this.responseJSON['favorite'];
    }

    getEmailUrl() {
        return this.responseJSON['sendToEmailUrl'];
    }

    getReservationUrl() {
        return this.responseJSON['reservationUrl'];
    }

    getOrderDecorationUrl() {
        return this.responseJSON['orderDecorationUrl'];
    }

    getConsultation() {
        return this.responseJSON['getConsultation'];
    }

    getPanoramaProp() {
        let props = ['videoPanoramaUrl', 'videoPanoramaYoutube', 'panoramaUrl'], prop = {};
        props.forEach((element, index) => {
            if (this.responseJSON[element]) prop = {index: index, prop: element};
        });
        return prop;
    }

    getPanoramaUrl() {
        return this.responseJSON[this.getPanoramaProp().prop];
    }

    getPanoramaType() {
        let panoramaTypes = ['data-player=local', 'data-player=youtube', 'target=_blank'];
        return panoramaTypes[this.getPanoramaProp().index];
    }

    getPanoramaClass() {
        if (this.getPanoramaProp().index < 2) {
            return 'js-video-popup';
        } else {
            return '';
        }
    }


    get360Prop() {
        let props = ['video360Url', 'video360Youtube', 'overview360Url'], prop = {};
        props.forEach((element, index) => {
            if (this.responseJSON[element]) prop = {index: index, prop: element};
        });
        return prop;
    }

    get360Url() {
        return this.responseJSON[this.get360Prop().prop];
    }

    get360Type() {
        let panoramaTypes = ['data-player=local', 'data-player=youtube', 'target=_blank'];
        return panoramaTypes[this.get360Prop().index];
    }

    get360Class() {
        if (this.get360Prop().index < 2) {
            return 'js-video-popup';
        } else {
            return '';
        }
    }


    getHousingImage() {
        return this.responseJSON['housingImage']
    }

    getHousingAzimuth() {
        return this.responseJSON['housingAzimuth'];
    }

    getSectionViewBox() {
        return this.responseJSON["housingViewBox"];
    }

    /**
     * @returns {SectionFloor[]}
     */
    getSectionsCoordinates() {
        return map(this.responseJSON["sections"], (sectionsJSON) => {
            return new HousingSection(sectionsJSON);
        });
    }

    getSectionNumber() {
        return this.responseJSON["sectionNumber"];
    }


    getHousingId() {
        return this.responseJSON["housingId"];
    }

    getHousingCode() {
        return this.responseJSON["housingCode"];
    }

    getSectionId() {
        return this.responseJSON["sectionId"];
    }

    getSectionPrev() {
        let prev = this.responseJSON["sectionNav"]["prevId"],
            sections = this.responseJSON["sections"],
            sectionsCount = sections.length;

        if (prev === null) {
            prev = sections[sectionsCount - 1].id;
        }

        return prev;
    }

    getSectionNext() {
        let next = this.responseJSON["sectionNav"]["nextId"],
            sections = this.responseJSON["sections"];

        if (next === null) {
            next = sections[0].id;
        }

        return next;
    }

    getFloorId() {
        return this.responseJSON["floorId"];
    }

    getSectionMinischeme() {
        let minischeme = this.responseJSON["sectionMinischeme"];

        if (minischeme === null || minischeme === '') {
            return null;
        } else {
            return minischeme
        }

    }
}

class HousingSection {
    constructor(sectionsJSON) {
        this.sectionsJSON = sectionsJSON;
    }

    getId() {
        return this.sectionsJSON["id"];
    }

    getNumber() {
        return this.sectionsJSON["number"];
    }

    getCoordinates() {
        return this.sectionsJSON["coordinates"];
    }

}


// WEBPACK FOOTER //
// ./js/api/GetFlatResponse.js